import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Record from "../views/Record.vue";
import Sucess from "../views/Sucess.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/record",
    name: "Record",
    component: Record,
  },
  {
    path: "/sucess",
    name: "Sucess",
    component: Sucess,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
